module.exports = __webpack_public_path__ + "img/electronic_fuel_injection.62ea3b55.svg";